/**
 * @generated SignedSource<<805b86e8593bf03aff9d180d93303564>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetWorkAddressForUserMutationInput = {
  clientMutationId?: string | null;
  orgRelayId: string;
  rawAddress?: string | null;
};
export type SetWorkAddressForUserMutation$variables = {
  input: SetWorkAddressForUserMutationInput;
};
export type SetWorkAddressForUserMutation$data = {
  readonly setWorkAddressForUser: {
    readonly clientMutationId: string | null;
    readonly address: {
      readonly rawAddress: string;
    } | null;
  } | null;
};
export type SetWorkAddressForUserMutation = {
  variables: SetWorkAddressForUserMutation$variables;
  response: SetWorkAddressForUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetWorkAddressForUserMutationPayload",
    "kind": "LinkedField",
    "name": "setWorkAddressForUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Address",
        "kind": "LinkedField",
        "name": "address",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rawAddress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetWorkAddressForUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetWorkAddressForUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "70d47012505624b304193135475bd495",
    "id": null,
    "metadata": {},
    "name": "SetWorkAddressForUserMutation",
    "operationKind": "mutation",
    "text": "mutation SetWorkAddressForUserMutation(\n  $input: SetWorkAddressForUserMutationInput!\n) {\n  setWorkAddressForUser(input: $input) {\n    clientMutationId\n    address {\n      rawAddress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7eb4138e818586b76b8bd9d5b882fc73";

export default node;
